import type { WhatsappMessage } from "../types/whatsapp.types";
import { keys } from "@/lib/i18n/portal";

const copy = keys.whatsapp;
const templateNames: Record<string, string> = {
  order_confirmation: copy.purposes.order_confirmation,
  order_confirmation_ar: copy.purposes.order_confirmation,
  order_placed_tracking: copy.orderTracking,
  order_placed_tracking_ar: copy.orderTracking,
  hello_world: copy.welcome,
};
const providerLabels: Record<string, string> = {
  UTILITY: copy.UTILITY,
  MARKETING: copy.MARKETING,
  AUTHENTICATION: copy.AUTHENTICATION,
  REGULAR: copy.standardRate,
};

export function templateDisplayName(name: string, t: (key: string) => string) {
  const key = Object.hasOwn(templateNames, name)
    ? templateNames[name]
    : undefined;
  return key ? t(key) : name;
}

export function providerLabel(value: string, t: (key: string) => string) {
  const key = providerLabels[value.toUpperCase()];
  return key ? t(key) : value;
}

export function languageDisplayName(code: string, locale: string) {
  try {
    return (
      new Intl.DisplayNames([locale], { type: "language" }).of(
        code.replaceAll("_", "-"),
      ) ?? code
    );
  } catch {
    return code;
  }
}

export function formatApproximateCost(
  value: number | null,
  currency: string | null,
  locale: string,
  unavailable: string,
) {
  if (value === null || !currency) return unavailable;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 4,
    }).format(value);
  } catch {
    return unavailable;
  }
}

export function messageStatusTimestamp(
  message: WhatsappMessage,
): string | null {
  switch (message.status) {
    case "read":
      return message.readAt;
    case "delivered":
      return message.deliveredAt;
    case "failed":
      return message.failedAt;
    case "sent":
      return message.sentAt;
    case "accepted":
      return message.acceptedAt;
    default:
      return message.attemptedAt;
  }
}

export function metaDeliveryStatus(message: WhatsappMessage): string | null {
  if (["sent", "delivered", "read"].includes(message.status))
    return message.status;
  return message.status === "failed" && message.failedAt ? "failed" : null;
}
